import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FireflyChartBoilerplateModule } from '../common/chart-boilerplate/chart-boilerplate.module';
import { FireflyLineSeriesModule } from '../common/lines/line-series/line-series.module';
import { FireflyLineChartMobilePopoverComponent } from '../common/mobile-popovers/line-chart-popover/line-chart-mobile-popover.component';
import { FireflyLineChartComponent } from './line-chart.component';

@NgModule({
  imports: [
    CommonModule,
    FireflyLineSeriesModule,
    FireflyChartBoilerplateModule,
    FireflyLineChartMobilePopoverComponent
  ],
  declarations: [FireflyLineChartComponent],
  exports: [FireflyLineChartComponent]
})
export class FireflyLineChartModule {}
